import { defineStore } from "pinia";

export const useAppStore = defineStore("app", {
  state: () => ({ appName: "Promotions SPA" }),
  getters: {
    appDesc: (state) =>
      state.appName + " is a single page application for booking promotions.",
  },
  actions: {
    setAppName(name: string) {
      this.appName = name;
    },
  },
});
